import React from "react";
import Progress2Svg from "../../../assets/svgicons/progress-bar/progress_bar_2.svg";

const Progress2 = (props) => {
  return <img src={Progress2Svg} alt="Progress 2" {...props} />;
};

export default Progress2;
